import { HELP_ICON_HTML, bindFinishTourOnClick, unbindFinishTourOnClick } from '../../tourUi'

const selectProtocol = (protocol) => {
    const radio = document.querySelector(`[data-tour="protocol-${protocol}"] input`)

    if (radio && !radio.checked) {
        radio.click()
    }
}

const clickTab = (selector) => {
    const tabElement = document.querySelector(selector)

    if (tabElement && !tabElement.classList.contains('react-tabs__tab--selected')) {
        tabElement.click()
    }

    return tabElement
}

const isGatewayChecked = () => {
    const checkbox = document.querySelector('#isGateway')
    if (checkbox) return Boolean(checkbox.checked)

    const campo = document.querySelector('[data-tour="form-campo-gateway"]')
    return Boolean(campo && getComputedStyle(campo).display !== 'none')
}

const selectProtocolAndMoveNext = (tourManager, protocol, nextSelector) => () => {
    selectProtocol(protocol)

    tourManager.waitForElement(nextSelector)
        .then(() => tourManager.moveNext())
        .catch(() => {})
}

const selectProtocolAndMovePrev = (tourManager, protocol, prevSelector) => () => {
    selectProtocol(protocol)

    tourManager.waitForElement(prevSelector)
        .then(() => tourManager.movePrevious())
        .catch(() => {})
}

const clickTabAndMoveNext = (tourManager, tabSelector) => () => {
    clickTab(tabSelector)
    setTimeout(() => tourManager.moveNext(), 150)
}

const mostrarAviso = (message, options = {}) => {
    document.dispatchEvent(new CustomEvent('showAviso', {
        detail: {
            message,
            callback: options.callback ?? null,
            callbackClose: options.callbackClose ?? null,
            callbackLabelClose: options.callbackLabelClose ?? 'Fechar',
            callbackLabel: options.callbackLabel ?? 'Continuar',
        },
    }))
}

const isFormularioPreenchido = () => {
    const root = document.querySelector('[data-tour="equipamento-edit-root"]')
    return root?.getAttribute('data-form-preenchido') === 'true'
}

const AVISO_SALVAR_EQUIPAMENTO =
    'Os dados preenchidos durante o tour serão <b>salvos</b> como um novo equipamento.'

const salvarEquipamento = () => {
    document.querySelector('[data-tour="equipamento-salvar"]')?.click()
}

const concluirTour = (tourManager) => () => {
    tourManager.finish('novo-equipamento')

    if (!isFormularioPreenchido()) return

    mostrarAviso(AVISO_SALVAR_EQUIPAMENTO, {
        callback: salvarEquipamento,
        callbackLabelClose: 'Cancelar',
    })
}

const INDEX_GATEWAY_STEP = 9

const buildSalvarEConclusaoSteps = (tourManager, { onPrevFromSalvar, onPrevFromDone, doneDescription } = {}) => [
    {
        element: '[data-tour="equipamento-salvar"]',
        popover: {
            title: 'Salvar',
            description: 'Após preencher os campos necessários, salve o equipamento.',
            side: 'top',
            align: 'start',
            onPrevClick: onPrevFromSalvar,
        },
        onHighlighted: (element) => {
            bindFinishTourOnClick(element, tourManager, 'novo-equipamento')
        },
        onDeselected: (element) => {
            unbindFinishTourOnClick(element)
        },
    },
    {
        popover: {
            title: 'Tudo pronto!',
            description: doneDescription ||
                'Após finalizar o cadastro, edite este equipamento para realizar a parametrização. Essa etapa é essencial para concluir os cadastros iniciais e será utilizada posteriormente no cadastro do Monitorado.',
            onPrevClick: onPrevFromDone,
            onDoneClick: concluirTour(tourManager),
        },
    },
]

const buildPrefixSteps = (tourManager, applyBranch) => [
    {
        popover: {
            title: 'Cadastro de Equipamento',
            description: 'Aqui você cadastra os dispositivos que enviam dados para a plataforma. Este é o primeiro passo dos cadastros básicos e será usado depois no Monitorado.',
        },
    },
    {
        element: '[data-tour="grid-novo-btn"]',
        popover: {
            title: 'Novo equipamento',
            description: 'Para iniciar um novo cadastro, clique em <strong>Próximo</strong>. Vamos percorrer o formulário e as abas principais.',
            side: 'bottom',
            align: 'start',
            onNextClick: () => {
                tourManager.navigateAndWait('/equipamento/novo', '[data-tour="form-imei"]', 2)
                    .then(() => tourManager.moveTo(2))
                    .catch(() => {})
            },
            onPrevClick: () => tourManager.movePrevious(),
        },
    },
    {
        element: '[data-tour="form-imei"]',
        popover: {
            title: 'IMEI',
            description: 'É o IMEI, ou número de identificação do equipamento. Após salvar, não poderá ser alterado.',
            side: 'bottom',
            align: 'start',
            onPrevClick: () => {
                tourManager.navigateAndWait('/equipamento', '[data-tour="grid-novo-btn"]', 1)
                    .then(() => tourManager.moveTo(1))
                    .catch(() => {})
            },
        },
    },
    {
        element: '[data-tour="form-fabricante"]',
        popover: {
            title: 'Fabricante',
            description: 'Selecione o fabricante do equipamento.',
            side: 'bottom',
            align: 'start',
        },
    },
    {
        element: '[data-tour="form-modelo"]',
        popover: {
            title: 'Modelo',
            description: 'Selecione o modelo do equipamento.',
            side: 'bottom',
            align: 'start',
        },
    },
    {
        element: '[data-tour="form-comunicacao"]',
        popover: {
            title: 'Comunicação',
            description: 'Define a operadora/forma de comunicação do equipamento.',
            side: 'bottom',
            align: 'start',
        },
    },
    {
        element: '[data-tour="form-simcard"]',
        popover: {
            title: 'Número do SimCard',
            description: 'Informe o número do SimCard do equipamento. Este campo é habilitado apenas quando a comunicação selecionada é via SimCard.',
            side: 'bottom',
            align: 'start',
        },
    },
    {
        element: '[data-tour="form-emails"]',
        popover: {
            title: 'Tempo limite sem comunicação',
            description: 'Defina, em minutos, o tempo limite sem comunicação para este equipamento. Após esse período, um alerta será enviado para o e-mail cadastrado.',
            side: 'top',
            align: 'start',
        },
        onHighlighted: (element) => {
            const button = element.querySelector('[data-tour="form-emails-selecionar"]')
            if (!button) return

            const onSelecionarEmails = () => tourManager.minimize()

            button.addEventListener('click', onSelecionarEmails)
            button._hdvTourEmailsClick = onSelecionarEmails
        },
        onDeselected: (element) => {
            const button = element?.querySelector?.('[data-tour="form-emails-selecionar"]')
            if (button?._hdvTourEmailsClick) {
                button.removeEventListener('click', button._hdvTourEmailsClick)
                delete button._hdvTourEmailsClick
            }
        },
    },
    {
        element: '[data-tour="form-timezone"]',
        popover: {
            title: 'Timezone',
            description: 'Selecione o fuso horário do equipamento, usado como referência para as datas e horários dos dados recebidos.',
            side: 'top',
            align: 'start',
        },
    },
    {
        element: '[data-tour="form-gateway-check"]',
        popover: {
            title: 'Gateway',
            description: 'Marque esta opção caso o equipamento que está sendo cadastrado seja um gateway. Após marcar essa opção e salvar, a ação não poderá ser desfeita.',
            side: 'top',
            align: 'start',
            onNextClick: () => applyBranch(isGatewayChecked()),
        },
    },
]

const buildMqttSteps = (tourManager, { onPrevFromMqtt, onNextAfterMqtt }) => [
    {
        element: '[data-tour="protocol-mqtt"]',
        popover: {
            title: 'MQTT',
            description: 'Use MQTT quando o equipamento se conecta diretamente ao servidor de mensagens da plataforma.',
            side: 'bottom',
            align: 'start',
            onNextClick: selectProtocolAndMoveNext(
                tourManager,
                'mqtt',
                '[data-tour="mqtt-topicos-personalizados"]'
            ),
            onPrevClick: onPrevFromMqtt,
        },
    },
    {
        element: '[data-tour="mqtt-topicos-personalizados"]',
        popover: {
            title: 'Tópicos personalizados',
            description: 'Marque esta opção somente se o equipamento utilizar tópicos próprios. Se não marcar, a plataforma preenche automaticamente Publicar, Receber, Usuário e Senha.',
            side: 'bottom',
            align: 'start',
            onPrevClick: selectProtocolAndMovePrev(
                tourManager,
                'mqtt',
                '[data-tour="protocol-mqtt"]'
            ),
        },
    },
    {
        element: '[data-tour="mqtt-topico-publicar"]',
        popover: {
            title: 'Publicar',
            description: 'É o tópico MQTT em que o equipamento publica os dados enviados para a plataforma.',
            side: 'bottom',
            align: 'start',
            onPrevClick: selectProtocolAndMovePrev(
                tourManager,
                'mqtt',
                '[data-tour="mqtt-topicos-personalizados"]'
            ),
        },
    },
    {
        element: '[data-tour="mqtt-topico-receber"]',
        popover: {
            title: 'Receber',
            description: 'É o tópico MQTT pelo qual o equipamento recebe mensagens ou comandos da plataforma.',
            side: 'bottom',
            align: 'start',
            onPrevClick: selectProtocolAndMovePrev(
                tourManager,
                'mqtt',
                '[data-tour="mqtt-topico-publicar"]'
            ),
        },
    },
    {
        element: '[data-tour="mqtt-usuario"]',
        popover: {
            title: 'Usuário MQTT',
            description: 'A plataforma gera este usuário automaticamente quando o equipamento é salvo.',
            side: 'bottom',
            align: 'start',
            onPrevClick: selectProtocolAndMovePrev(
                tourManager,
                'mqtt',
                '[data-tour="mqtt-topico-receber"]'
            ),
        },
    },
    {
        element: '[data-tour="mqtt-senha"]',
        popover: {
            title: 'Senha MQTT',
            description: 'A plataforma gera esta senha automaticamente quando o equipamento é salvo.',
            side: 'bottom',
            align: 'start',
            onPrevClick: selectProtocolAndMovePrev(
                tourManager,
                'mqtt',
                '[data-tour="mqtt-usuario"]'
            ),
        },
    },
    {
        element: '[data-tour="detalhes-comunicacao-mqtt"]',
        popover: {
            title: 'Dados do servidor MQTT',
            description: 'Estes são o DNS e as portas do servidor MQTT que devem ser utilizados na configuração do equipamento.',
            side: 'top',
            align: 'start',
            onPrevClick: selectProtocolAndMovePrev(
                tourManager,
                'mqtt',
                '[data-tour="mqtt-senha"]'
            ),
            onNextClick: onNextAfterMqtt,
        },
    },
]

const buildProtocolCommonStart = (tourManager, { optionsDescription, onPrevFromTab }) => [
    {
        element: '[data-tour="tab-protocolo"]',
        popover: {
            title: 'Aba Protocolo',
            description: 'Agora vamos definir como o equipamento vai comunicar. Clique em <strong>Próximo</strong>.',
            side: 'bottom',
            align: 'start',
            onNextClick: clickTabAndMoveNext(tourManager, '[data-tour="tab-protocolo"]'),
            onPrevClick: () => {
                clickTab('[data-tour="tab-equipamento"]')
                setTimeout(onPrevFromTab, 150)
            },
        },
    },
    {
        element: '[data-tour="form-protocolo-opcoes"]',
        popover: {
            title: 'Como o equipamento vai comunicar',
            description: optionsDescription,
            side: 'bottom',
            align: 'start',
            onPrevClick: () => {
                clickTab('[data-tour="tab-protocolo"]')
                setTimeout(() => tourManager.movePrevious(), 150)
            },
        },
    },
    {
        element: '[data-tour="protocol-outro"]',
        popover: {
            title: 'Outro',
            description: 'Selecione esta opção quando o equipamento não se enquadrar nas demais opções. Nesse caso, não há configuração adicional de comunicação.',
            side: 'bottom',
            align: 'start',
        },
    },
    {
        element: '[data-tour="protocol-http"]',
        popover: {
            title: 'HTTP',
            description: 'Use HTTP quando o equipamento envia dados por requisições HTTP. Clique em <strong>Próximo</strong> para ver a URL de integração gerada pela plataforma.',
            side: 'bottom',
            align: 'start',
            onNextClick: selectProtocolAndMoveNext(
                tourManager,
                'http',
                '[data-tour="detalhes-comunicacao-http"]'
            ),
        },
    },
    {
        element: '[data-tour="detalhes-comunicacao-http"]',
        popover: {
            title: 'URL da comunicação HTTP',
            description: 'Após finalizar o seu cadastro e salvar o equipamento, é aqui que será gerada a URL que deve ser configurada no equipamento para a comunicação HTTP com a plataforma.',
            side: 'top',
            align: 'start',
            onPrevClick: selectProtocolAndMovePrev(
                tourManager,
                'http',
                '[data-tour="protocol-http"]'
            ),
        },
    },
]

const buildGatewayBranch = (tourManager, applyBranch) => {
    const indexStatusStep = INDEX_GATEWAY_STEP + 2
    const indexMqttDetailsStep = INDEX_GATEWAY_STEP + 1 + 2 + 5 + 6
    const indexLiveDataTabStep = indexMqttDetailsStep + 1
    const indexDoneStep = indexLiveDataTabStep + 1

    return [
        {
            element: '[data-tour="form-campo-gateway"]',
            popover: {
                title: 'Campo ID do equipamento',
                description: 'Informe onde estão os dados dos dispositivos na mensagem do gateway. Exemplo: data.0.bn',
                side: 'top',
                align: 'start',
                onPrevClick: () => applyBranch(isGatewayChecked(), INDEX_GATEWAY_STEP),
            },
        },
        {
            element: '[data-tour="form-status"]',
            popover: {
                title: 'Status',
                description: 'Ativo, Bloqueado ou Cancelado. Equipamentos que não possuem status Ativo não comunicam com a plataforma.',
                side: 'top',
                align: 'start',
                onPrevClick: () => tourManager.movePrevious(),
            },
        },
        ...buildProtocolCommonStart(tourManager, {
            optionsDescription:
                'Para gateway, as opções disponíveis são MQTT, HTTP e Outro. A escolha depende de como o seu equipamento envia os dados.',
            onPrevFromTab: () => tourManager.moveTo(indexStatusStep),
        }),
        ...buildMqttSteps(tourManager, {
            onPrevFromMqtt: selectProtocolAndMovePrev(
                tourManager,
                'http',
                '[data-tour="detalhes-comunicacao-http"]'
            ),
            onNextAfterMqtt: () => tourManager.moveTo(indexLiveDataTabStep),
        }),
        {
            element: '[data-tour="tab-dados-vivo"]',
            popover: {
                title: 'Aba Dados ao vivo',
                description: 'Esta aba só é liberada após salvar o cadastro de um equipamento que utiliza protocolo MQTT. Caso queira consultar os pacotes de comunicação do seu equipamento, acesse esta aba ao editar para obter maiores informações.',
                side: 'bottom',
                align: 'start',
                onPrevClick: () => {
                    clickTab('[data-tour="tab-protocolo"]')
                    setTimeout(() => tourManager.moveTo(indexMqttDetailsStep), 150)
                },
            },
        },
        ...buildSalvarEConclusaoSteps(tourManager, {
            onPrevFromSalvar: () => tourManager.moveTo(indexLiveDataTabStep),
            onPrevFromDone: () => tourManager.movePrevious(),
            doneDescription:
                'Como este equipamento é um gateway, ele não consome acesso e, após salvar, ficam disponíveis as abas Equipamento, Protocolo e Dados ao vivo (quando o protocolo for MQTT).',
        }),
    ]
}

const buildNormalBranch = (tourManager, applyBranch) => {
    const indexStatusStep = INDEX_GATEWAY_STEP + 1
    const indexAccessTypeStep = INDEX_GATEWAY_STEP + 2
    const indexMqttDetailsStep = INDEX_GATEWAY_STEP + 1 + 2 + 5 + 2 + 6
    const indexParametrizationTabStep = indexMqttDetailsStep + 1
    const indexLiveDataTabStep = indexParametrizationTabStep + 2

    return [
        {
            element: '[data-tour="form-status"]',
            popover: {
                title: 'Status',
                description: 'Ativo: para quando o equipamento for consumir um acesso. Bloqueado: impede a comunicação. Cancelado: remove o acesso.',
                side: 'top',
                align: 'start',
                onPrevClick: () => applyBranch(isGatewayChecked(), INDEX_GATEWAY_STEP),
            },
        },
        {
            element: '[data-tour="form-tipo-acesso"]',
            popover: {
                title: 'Tipo do Acesso',
                description: 'O acesso define quantos parâmetros o equipamento pode ter e com que frequência os dados serão apresentados na plataforma. Os acessos são contratados conosco e seguem o formato <strong>parâmetros/tempo</strong>.<br><br>Por exemplo, um acesso <strong>1/5</strong> permite 1 parâmetro e apresenta seus dados a cada 5 minutos. Mesmo que o equipamento envie dados com mais frequência, a plataforma respeita o intervalo definido pelo acesso.<br><br>Somente equipamentos com status <strong>Ativo</strong> podem ter um tipo de acesso definido.',
                side: 'top',
                align: 'start',
                onPrevClick: () => tourManager.moveTo(indexStatusStep),
            },
        },
        ...buildProtocolCommonStart(tourManager, {
            optionsDescription:
                'Existem quatro opções: MQTT, Gateway, HTTP e Outro. A escolha depende de como o seu equipamento envia os dados.',
            onPrevFromTab: () => tourManager.moveTo(indexAccessTypeStep),
        }),
        {
            element: '[data-tour="protocol-gateway"]',
            popover: {
                title: 'Gateway',
                description: 'Use esta opção quando o equipamento comunica por meio de um gateway cadastrado na plataforma.',
                side: 'bottom',
                align: 'start',
                onNextClick: selectProtocolAndMoveNext(
                    tourManager,
                    'gateway',
                    '[data-tour="gateway-select"]'
                ),
                onPrevClick: selectProtocolAndMovePrev(
                    tourManager,
                    'http',
                    '[data-tour="detalhes-comunicacao-http"]'
                ),
            },
        },
        {
            element: '[data-tour="gateway-select"]',
            popover: {
                title: 'Selecione o Gateway',
                description: 'Escolha aqui a qual gateway este equipamento será associado.',
                side: 'right',
                align: 'start',
                onPrevClick: selectProtocolAndMovePrev(
                    tourManager,
                    'gateway',
                    '[data-tour="protocol-gateway"]'
                ),
            },
        },
        ...buildMqttSteps(tourManager, {
            onPrevFromMqtt: selectProtocolAndMovePrev(
                tourManager,
                'gateway',
                '[data-tour="gateway-select"]'
            ),
            onNextAfterMqtt: () => tourManager.moveTo(indexParametrizationTabStep),
        }),
        {
            element: '[data-tour="tab-parametrizacao"]',
            popover: {
                title: 'Aba Parametrização',
                description: 'Esta aba será liberada após salvar o cadastro de um novo equipamento, e é essencial para concluir os cadastros básicos da plataforma. Recomendamos editar o equipamento novamente e clicar no ícone de <strong>Ajuda</strong> <span class="hdv-tour-help-icon-inline" aria-hidden="true"><svg viewBox="0 0 24 24" width="20" height="20" focusable="false"><circle cx="12" cy="12" r="9.25" fill="none" stroke="currentColor" stroke-width="1.75"/><path fill="currentColor" d="M9.6 9.2c.2-1.35 1.2-2.35 2.7-2.35 1.55 0 2.65.95 2.65 2.35 0 1.05-.55 1.7-1.45 2.25-.85.5-1.15.85-1.15 1.55v.45h-1.55v-.55c0-1.15.45-1.75 1.4-2.3.75-.45 1.05-.8 1.05-1.4 0-.7-.5-1.15-1.25-1.15-.75 0-1.25.45-1.4 1.2l-1.6-.25zm2.05 7.05c-.6 0-1.05-.45-1.05-1.05s.45-1.05 1.05-1.05 1.05.45 1.05 1.05-.45 1.05-1.05 1.05z"/></svg></span> para acessar o guia completo de parametrização.',
                side: 'bottom',
                align: 'start',
                onPrevClick: () => {
                    clickTab('[data-tour="tab-protocolo"]')
                    setTimeout(() => tourManager.moveTo(indexMqttDetailsStep), 150)
                },
            },
        },
        {
            element: '[data-tour="tab-comandos"]',
            popover: {
                title: 'Aba Comandos',
                description: 'Esta aba será liberada após salvar um novo equipamento. Se desejar enviar comandos ao equipamento, edite-o novamente e clique no ícone de <strong>Ajuda</strong> <span class="hdv-tour-help-icon-inline" aria-hidden="true"><svg viewBox="0 0 24 24" width="20" height="20" focusable="false"><circle cx="12" cy="12" r="9.25" fill="none" stroke="currentColor" stroke-width="1.75"/><path fill="currentColor" d="M9.6 9.2c.2-1.35 1.2-2.35 2.7-2.35 1.55 0 2.65.95 2.65 2.35 0 1.05-.55 1.7-1.45 2.25-.85.5-1.15.85-1.15 1.55v.45h-1.55v-.55c0-1.15.45-1.75 1.4-2.3.75-.45 1.05-.8 1.05-1.4 0-.7-.5-1.15-1.25-1.15-.75 0-1.25.45-1.4 1.2l-1.6-.25zm2.05 7.05c-.6 0-1.05-.45-1.05-1.05s.45-1.05 1.05-1.05 1.05.45 1.05 1.05-.45 1.05-1.05 1.05z"/></svg></span> para acessar o guia completo desta funcionalidade.',
                side: 'bottom',
                align: 'start',
            },
        },
        {
            element: '[data-tour="tab-dados-vivo"]',
            popover: {
                title: 'Aba Dados ao vivo',
                description: 'Esta aba só é liberada após salvar o cadastro de um equipamento que utiliza protocolo MQTT. Caso queira consultar os pacotes de comunicação do seu equipamento, acesse esta aba ao editar para obter maiores informações.',
                side: 'bottom',
                align: 'start',
            },
        },
        ...buildSalvarEConclusaoSteps(tourManager, {
            onPrevFromSalvar: () => tourManager.moveTo(indexLiveDataTabStep),
            onPrevFromDone: () => tourManager.movePrevious(),
        }),
    ]
}

const buildNovoEquipamentoTourSteps = (tourManager) => {
    const isGatewayBranchActive = () => {
        const steps = tourManager.driverObj?.getConfig?.('steps') || []
        return steps.some((step) => step.element === '[data-tour="form-campo-gateway"]')
    }

    const applyBranch = (gateway, moveToIndex = INDEX_GATEWAY_STEP + 1) => {
        if (gateway === isGatewayBranchActive()) {
            tourManager.moveTo(moveToIndex)
            return
        }

        const prefix = buildPrefixSteps(tourManager, applyBranch)
        const suffix = gateway ? buildGatewayBranch(tourManager, applyBranch) : buildNormalBranch(tourManager, applyBranch)
        const steps = [...prefix, ...suffix]

        const applySteps = () => tourManager.setSteps(steps, moveToIndex)

        if (gateway && moveToIndex === INDEX_GATEWAY_STEP + 1) {
            setTimeout(applySteps, 150)
        } else {
            applySteps()
        }
    }

    const gateway = isGatewayChecked()
    const prefix = buildPrefixSteps(tourManager, applyBranch)
    const suffix = gateway ? buildGatewayBranch(tourManager, applyBranch) : buildNormalBranch(tourManager, applyBranch)

    return [...prefix, ...suffix]
}

export default buildNovoEquipamentoTourSteps
